import React from 'react';
import { FiClock } from 'react-icons/fi';

/**
 * TimeIcon
 * Ikona hodín na znázornenie časových údajov alebo aktivít.
 */
const TimeIcon = ({ className = 'inline-block align-middle', ...props }) => (
  <FiClock className={className} {...props} />
);

export default TimeIcon;

